<script lang="ts">
    import { token } from "../stores/token";
    import { url } from "../stores/stream";
    import { gameId, streamLabel, environment } from "../constants/api";
    import { login, fetchStreamUrl } from "../utils/api";
    import { onMount } from "svelte";
    import usernameIcon from "@fortawesome/fontawesome-free/svgs/solid/user.svg";
    import passwordIcon from "@fortawesome/fontawesome-free/svgs/solid/unlock.svg";
    let inputUsername: string;
    let inputPassword: string;
    let inputFocus: HTMLElement;
    let loading: boolean = false;
    let errorMessage: string | undefined = undefined;

    onMount(() => {
        inputFocus.focus();
    });
    const onSubmit = async () => {
        loading = true;
        try {
            $token = await login(environment, inputUsername, inputPassword);
            errorMessage = undefined;

            if ($url === "") {
                $url = await fetchStreamUrl(
                    environment,
                    gameId,
                    streamLabel,
                    $token
                );
            }
        } catch (e) {
            errorMessage = e.message;
            $token = undefined;
        } finally {
            loading = false;
        }
    };

    const onKeydown = async (event) => {
        if (event.key === "Enter") {
            if (inputUsername && inputPassword) {
                await onSubmit();
            }
        }
    };
</script>

<style>
    .modal-content {
        max-width: 320px;
    }
    button {
        margin-left: auto;
        margin-right: auto;
        display: block;
    }
</style>

<svelte:window on:keydown={onKeydown} />

<div class="modal {$token === undefined ? 'is-active' : ''}">
    <div class="modal-background" />
    <div class="modal-content">
        <div class="container">
            <div class="notification is-link">
                <div class="field">
                    <div class="control has-icons-left">
                        <span class="icon is-small is-left">
                            <img src={usernameIcon} width="15em" alt="" />
                        </span>
                        <input
                            bind:value={inputUsername}
                            bind:this={inputFocus}
                            class="input is-rounded"
                            type="text"
                            placeholder="Username" />
                    </div>
                </div>
                <div class="field">
                    <div class="control has-icons-left">
                        <span class="icon is-small is-left">
                            <img src={passwordIcon} width="15em" alt="" />
                        </span>
                        <input
                            bind:value={inputPassword}
                            class="input is-rounded"
                            type="password"
                            placeholder="Password" />
                    </div>
                    {#if errorMessage}
                        <p class="help is-danger">{errorMessage}</p>
                    {/if}
                </div>
                <div class="field">
                    <div class="control">
                        <button
                            class="button is-centered is-link {loading ? 'is-loading' : ''}"
                            disabled={!inputUsername || !inputPassword || loading}
                            on:click={onSubmit}>Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
